import { ILanguage } from "../models/language";

export const SET_LANGUAGES = "SET_LANGUAGES"

export const SetLanguages = (languages: ILanguage[]) => {
    return { type: SET_LANGUAGES, languages };
}